module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAeCAYAAAAhDE4sAAAAAXNSR0IArs4c6QAAAQ9JREFUSA2t1j0OgkAQBWAwNFSU1PRcAE+gjY2NZ+AOHIIzeAVv4AU8gBUaSzsbE4PvJZCMmy1mGDeZkCWz37KwPyTJwjKO4w5xRwyI7SIGDTeIN2IuNzOElmvEaxam62CC0KhGPAPkg/peDSG5QjwChNXWgpRocI0gnQUpAFwiSG9BcgDnCHLEvVQFITFDnCII72VaJEUyew0Lny5XIUxCch8KqPM9FRakiyD8YqUFaSMI505lQQ5owFkqC2dxbUHCRUiM66nRIittojoPvfuHNvcGzP+yBeb//ALzT0hiGOJ/lsiE+RetGKJ/GxGYf2MTmH+rFZh/8xeY/zgSWIPp4TsgBRbuFvYjW2A/PxFfI0ngnBBGT7YAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/back.png
// module id = P9/e
// module chunks = 1